// @ts-nocheck
import {Column} from 'react-table'
import {UserCustomHeader} from '../apps/user-management/users-list/table/columns/UserCustomHeader'
import {ReturnRecord, deleteReturn} from './api'
import {KTIcon} from '../../../_metronic/helpers'
import {Modal} from 'react-bootstrap'
import {toast} from 'react-hot-toast'
import {useState} from 'react'
import {useLayout} from '../../../_metronic/layout/core'

// ─── Helper ───────────────────────────────────────────────────────────────────

const formatSlug = (slug: string): string => {
  if (!slug) return ''
  return slug
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

// ─── Columns ──────────────────────────────────────────────────────────────────

const getReturnColumns = (
  productMap: Record<number, string>
): ReadonlyArray<Column<ReturnRecord>> => [
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Return ID'
        className='min-w-100px ps-4 text-center'
      />
    ),
    id: 'process_return_id',
    accessor: 'process_return_id',
    sortType: 'basic',
    Cell: ({...props}) => (
      <span className='badge badge-light-dark fw-bold'>
        {props.data[props.row.index].process_return_id}
      </span>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Type' className='min-w-125px text-center' />
    ),
    accessor: 'return_type',
    sortType: 'string',
    Cell: ({...props}) => <div>{formatSlug(props.data[props.row.index].return_type)}</div>,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Product' className='min-w-150px text-center' />
    ),
    accessor: 'product_id',
    sortType: 'basic',
    Cell: ({...props}) => {
      const productId = props.data[props.row.index].product_id
      return <div>{productMap[productId] ?? '-'}</div>
    },
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Quantity' className='min-w-100px text-center' />
    ),
    accessor: 'quantity',
    sortType: 'basic',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Reason' className='min-w-150px text-center' />
    ),
    accessor: 'reason',
    sortType: 'string',
    Cell: ({...props}) => <div>{formatSlug(props.data[props.row.index].reason)}</div>,
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Refund Amount'
        className='min-w-125px text-center'
      />
    ),
    accessor: 'refund_amount',
    sortType: 'basic',
    Cell: ({...props}) => (
      <div>&#8377; {props.data[props.row.index].refund_amount?.toLocaleString('en-IN')}</div>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Date' className='min-w-100px text-center' />
    ),
    accessor: 'return_date',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='min-w-100px text-center' />
    ),
    accessor: 'actions',
    sortable: false,
    Cell: ({...props}) => {
      const {company} = useLayout()
      const [showDeleteModal, setShowDeleteModal] = useState(false)

      const handleDelete = async () => {
        deleteReturn(company.value, props.data[props.row.index].process_return_id)
          .then((res) => res?.detail && toast.success(res.detail))
          .catch((err) => err && toast.error(err))
          .finally(() => setShowDeleteModal(false))
      }

      return (
        <>
          <div className='d-flex justify-content-center flex-shrink-0'>
            <div
              data-bs-toggle='tooltip'
              data-bs-trigger='hover'
              data-bs-dismiss-='click'
              title='Delete'
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
              onClick={() => setShowDeleteModal(true)}
            >
              <KTIcon iconName='trash' className='fs-3' />
            </div>
          </div>

          <Modal
            className='modal-sticky modal-sticky-lg modal-sticky-bottom-right'
            id='delete_return'
            role='dialog'
            data-backdrop='false'
            aria-hidden='true'
            tabIndex='-1'
            show={showDeleteModal}
            animation={false}
          >
            <div className='modal-content'>
              {/*begin::Header*/}
              <div className='d-flex align-items-center justify-content-between py-5 ps-8 pe-5 border-bottom'>
                <h5 className='fw-bold m-0'>Delete Return Record</h5>
                <div className='d-flex ms-2'>
                  {/*begin::Close*/}
                  <div
                    className='btn btn-icon btn-sm btn-light-primary ms-2'
                    data-bs-dismiss='modal'
                    onClick={() => setShowDeleteModal(false)}
                  >
                    <KTIcon className='fs-1' iconName='cross' />
                  </div>
                  {/*end::Close*/}
                </div>
              </div>
              {/*end::Header*/}
              <div className='text-center py-5 px-5'>
                Are you sure you want to delete this Return record? This action cannot be undone.
              </div>
              <div className='text-center pt-5 pb-5'>
                <button
                  type='reset'
                  onClick={() => setShowDeleteModal(false)}
                  className='btn btn-light me-3'
                  data-kt-users-modal-action='cancel'
                >
                  Cancel
                </button>
                <button
                  type='submit'
                  className='btn btn-primary'
                  data-kt-users-modal-action='submit'
                  onClick={handleDelete}
                >
                  Proceed
                </button>
              </div>
            </div>
          </Modal>
        </>
      )
    },
  },
]

export {getReturnColumns}
